"use client";

import { FC } from "react";
import ShareIcon from "@mui/icons-material/Share";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";

import { useStyles } from "./styles";
import { Image } from "@/types/thread";
import { useAppDispatch } from "@/redux/store";
import { generateAlert } from "@/redux/actions";
import DownloadButton from "@/components/common/DownloadButton";
import CloseIcon from "@/components/icons/Close";

interface ToolbarProps {
  selectedImage: Image;
  onClose: () => void;
  showCaption: boolean;
  toggleShowCaption: () => void;
  roomUUID?: string;
}

const Toolbar: FC<ToolbarProps> = ({
  selectedImage,
  onClose,
  showCaption,
  toggleShowCaption,
  roomUUID,
}) => {
  const { classes, cx } = useStyles();
  const dispatch = useAppDispatch();

  const handleShare = () => {
    if (!roomUUID) return;
    const url = `${process.env.NEXT_PUBLIC_BASE_URL}/idea/${roomUUID}`;
    navigator.clipboard.writeText(url);
    dispatch(
      generateAlert({ text: "Link copied to clipboard", type: "success" })
    );
  };

  return (
    <div className={classes.container}>
      {showCaption ? (
        <TextSnippetIcon
          className={cx(classes.icon, classes.activeIcon)}
          onClick={toggleShowCaption}
        />
      ) : (
        <TextSnippetOutlinedIcon
          className={classes.icon}
          onClick={toggleShowCaption}
        />
      )}
      {roomUUID && <ShareIcon className={classes.icon} onClick={handleShare} />}
      <DownloadButton
        url={selectedImage.url}
        className={classes.icon}
        variant="icon"
        color="white"
      />
      <CloseIcon className={classes.icon} onClick={onClose} />
    </div>
  );
};

export default Toolbar;
